import { FilterExpressionCollection as FilterExpressionCollection_internal } from "./FilterExpressionCollection";
/**
 * Represents a colleciton of filter expressions.
*/
var IgrFilterExpressionCollection = /** @class */ /*@__PURE__*/ (function () {
    function IgrFilterExpressionCollection() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrFilterExpressionCollection.prototype.createImplementation = function () {
        return new FilterExpressionCollection_internal();
    };
    Object.defineProperty(IgrFilterExpressionCollection.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrFilterExpressionCollection.prototype.onImplementationCreated = function () {
    };
    IgrFilterExpressionCollection.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrFilterExpressionCollection.prototype, "syncTarget", {
        get: function () {
            if (this.i.syncTarget == null) {
                return null;
            }
            if (!this.i.syncTarget.externalObject) {
                var e = new IgrFilterExpressionCollection();
                e._implementation = this.i.syncTarget;
                this.i.syncTarget.externalObject = e;
            }
            return this.i.syncTarget.externalObject;
        },
        set: function (v) {
            v == null ? this.i.syncTarget = null : this.i.syncTarget = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrFilterExpressionCollection.prototype, "onChanged", {
        get: function () {
            return this.i.onChanged;
        },
        set: function (v) {
            this.i.onChanged = v;
        },
        enumerable: true,
        configurable: true
    });
    IgrFilterExpressionCollection.prototype.add = function (item) {
        var iv = this.i.add(item);
        return (iv);
    };
    IgrFilterExpressionCollection.prototype.insert = function (index, item) {
        this.i.insert(index, item);
    };
    IgrFilterExpressionCollection.prototype.clear = function () {
        this.i.clear();
    };
    IgrFilterExpressionCollection.prototype.get = function (index) {
        var iv = this.i.get(index);
        return (iv);
    };
    IgrFilterExpressionCollection.prototype.indexOf = function (item) {
        var iv = this.i.indexOf(item);
        return (iv);
    };
    IgrFilterExpressionCollection.prototype.remove = function (item) {
        var iv = this.i.remove(item);
        return (iv);
    };
    IgrFilterExpressionCollection.prototype.removeAt = function (index) {
        var iv = this.i.removeAt(index);
        return (iv);
    };
    IgrFilterExpressionCollection.prototype.set = function (index, value) {
        var iv = this.i.set(index, value);
        return (iv);
    };
    IgrFilterExpressionCollection.prototype.size = function () {
        var iv = this.i.size();
        return (iv);
    };
    return IgrFilterExpressionCollection;
}());
export { IgrFilterExpressionCollection };
//# sourceMappingURL=igr-filter-expression-collection.js.map
